/**
 *API按模块分类，不要写死在具体组件中。后期修改比较方便
 *使用方法：
 * 1、 import该模块 import apiConfig,{login,captcha} from 'apiconfig'
 * 2、 获取登录url：apiConfig.login.login
 */
/**
 * 登录模块
 * @type {{login: string, resetPasswd: string}}
 */
export const login = {
  dxLogin: '/doc-exchange/api/auth/dxLogin/v100',
  dxLogout: '/doc-exchange/api/auth/dxLogout',
  getUserBriefInfo: '/doc-exchange/api/auth/getUserBriefInfo/v100',
  checkCompanyStatus: '/doc-exchange/api/auth/checkCompanyStatus/v100',
  changePw: '/doc-exchange/api/auth/changePw/v100',
  loginReminderForInitialSet: '/doc-exchange/api/ex-record/loginReminderForInitialSet', // 供应商端初始设置提醒
  changeCompany: '/doc-exchange/api/auth/changeCompany/v530', // 切换企业
  getCancellationInfo: '/doc-exchange/api/auth/getCancellationInfo/v530', // 获取注销信息
  cancelAdmin: '/doc-exchange/api/auth/cancelAdmin/v530', // 注销管理员
};

export const captcha = {
  captcha: '/doc-exchange/api/auth/captcha',
  getSmsCaptcha: '/commons-api/api/security/smsCaptcha', // 获取短信图形验证码
  checkSmsCaptcha: '/commons-api/api/security/checkSmsCaptcha/v4090', // 校验图形验证码
};
/*
 * 账户管理
 */
export const capitalManage = {
  getUserCompanyAccountInfo: '/doc-exchange/api/account/getUserCompanyAccountInfo/v100', // 获取用户账户管理信息
  getCashDetailList: '/doc-exchange/api/account/getCashDetailList/v100', // 现金收支明细
  exportCashDetailList: '/doc-exchange/api/account/exportCashDetailList', // 导出现金收支明细
  updateRechargeOrderNoticeFlag: '/doc-exchange/api/account/updateRechargeOrderNoticeFlag',
  getSendAccFee: '/doc-exchange/api/company/getSendAccFee/v210', // 获取资质发送费用
  getSuperPhone: '/doc-exchange/api/manager/getSuperPhone/v300', // 获取超级管理员的手机号
  changePayPw: '/doc-exchange/api/company/changePayPw/v300', // 修改支付密码
  getInvoice: '/doc-exchange/api/account/getInvoice/v400', // 申请发票获取
  isInvoiceCompleted: '/doc-exchange/api/account/isInvoiceCompleted/v400', // 获取发票信息是否完善
};

/*
 * 资质管理-首营设置、企业资质、药店资质
 * */
export const credentials = {
  getStoreRequiredDocs: '/doc-exchange/api/document/getStoreRequiredDocs/v100', // 获取药店需要给予的资质
  setStoreRequiredDocs: '/doc-exchange/api/document/setStoreRequiredDocs/v100', // 设置药店需要给予的资质
  getDocuments: '/doc-exchange/api/document/getDocuments/v100', // 我的资质
  operateDocument: '/doc-exchange/api/document/operateDocument/v100', //
  getOcrInfo: 'doc-exchange/api/document/getOcrInfo/v130', // 获取文字识别结果
  setOcrInfo: 'doc-exchange/api/document/setOcrInfo/v130', // 上传文字识别结果 和get 要求字段相同
  getWaterMarkImg: 'doc-exchange/api/document/getWaterMarkImg/', // 根据上传的图片url，增加水印后返回base64
  getStoreDownloadDocs: '/doc-exchange/api/document/getStoreDownloadDocs/v520', // 获取提供给药店下载的资质列表
  sealDoc: '/doc-exchange/api/document/sealDoc/v520', // 资质更新盖章
  batchSealDoc: '/doc-exchange/api/document/batchSealDocNew/v522', // 资质批量盖章
  getAbnormalDocList: '/doc-exchange/api/company/getAbnormalDocList', // 获取异常企业资质列表
  getCompanyRenameInfo: '/doc-exchange/api/company/getCompanyRenameStatus/v5110', // 获取企业更名状态
  submitCompanyRename: '/doc-exchange/api/company/submitCompanyRenameInfo/v5110', // 提交企业更名申请
  queryCanDownloadBeforeOrder: '/doc-exchange/api/document/selectCanDownloadBeforeOrder', // 查询交易前是否允许下载商家首营资质
  updateCanDownloadBeforeOrder: '/doc-exchange/api/document/updateCanDownloadBeforeOrder', // 更新交易前是否允许下载商家首营资质
  checkDocHasSyncField: '/doc-exchange/api/document/checkDocSyncField', // 证件是否有设置同步更新字段
  getColdChainDocList: '/doc-exchange/api/document/getColdChainDocuments', // 获取冷链资质列表
  docSpecialSeal: '/doc-exchange/api/document/docSpecialSeal', // 资质盖特殊章
  getReSealCount: '/doc-exchange/api/company/getReSealCount', // 获取当前剩余重盖章次数
  batchReSeal: '/doc-exchange/api/document/batchReSeal', // 资质批量重新盖章
};
/*
 * 资质管理-药品资质信息
 * */
export const drug = {
  deleteDrugInfo: '/doc-exchange/api/drug/deleteDrugInfo/v200', // 删除商品
  getDrugInfoList: '/doc-exchange/api/drug/getDrugInfoList/v200', // 获取商品信息列表
};
/*
 * 交换记录-收件箱、发件箱
 * */
export const records = {
  outbox: '/doc-exchange/api/ex-record/outbox/v100', // 发件箱
  inbox: '/doc-exchange/api/ex-record/inbox/v100', // 收件箱
  exportOutbox: '/doc-exchange/api/ex-record/exportOutbox/v100', // 导出发件箱
  exportInbox: '/doc-exchange/api/ex-record/exportInbox/v100', // 导出收件箱
  downloadPdf: '/doc-exchange/api/ex-record/downloadPdfs/v570', // 下载pdf
  previewPdfImage: '/doc-exchange/api/ex-record/previewPdfImage', // 预览pdf
  getExRecordStatsInfo: '/doc-exchange/api/ex-record/getExRecordStatsInfo/v100', // 交换记录统计
  getDExRecordList: '/doc-exchange/api/ex-record/getDExRecordList/v100', // 交换记录列表
  getBroadcastList: '/doc-exchange/api/ex-record/getBroadcastList', // 公告信息列表
  getBroadcastContent: '/doc-exchange/api/ex-record/getBroadcastContent', // 公告信息内容
  checkMultiCompanyAdmin: '/doc-exchange/api/ex-record/checkMultiCompanyAdmin', // 检查用户是否多公司管理员
  getUserStoreList: '/doc-exchange/api/ex-record/getUserStoreList', // 获取用户管理的药店列表(排除用户当前所在药店)
  exchangeDrugStore: '/doc-exchange/api/ex-record/exchangeDrugStore', // 切换药店
  getProviderInfo: '/doc-exchange/api/ex-record/getProviderInfo', // 获取供应商信息
  updateUserHeadPortrait: '/doc-exchange/api/ex-record/updateUserHeadPortrait', // 更新用户头像
  updateCompanyLogo: '/doc-exchange/api/ex-record/updateCompanyLogo', // 更新公司logo
  getInboxRecordCount: '/doc-exchange/api/ex-record/getInboxRecordCount/v200', // 获取收件箱未预览&未下载的记录数量
};
/*
 * 注册流程-企业信息完善,完善管理员信息
 * */
export const register = {
  getDocTypes: '/doc-exchange/api/document/getDocTypes/v100', // 获取可添加的资质
  getCompanyBaseInfo: '/doc-exchange/api/company/getCompanyBaseInfo/v100', // 首次企业信息
  getDocColumns: '/doc-exchange/api/company/getDocColumns/v100', // 获取证件字段
  getAllDocColumns: '/doc-exchange/api/company/getAllDocColumns/v100', // 获取所有证件字段
  completeCompanyInfo: '/doc-exchange/api/company/completeCompanyInfo/v100', // 完善企业信息
  getDxInfo: '/doc-exchange/api/company/getDxInfo/v100', // 获取首营资料信息
  getInvoiceInfoInProviderPlatform: '/doc-exchange/api/ex-record/getInvoiceInfoInProviderPlatform', // 获取供应商后台发票信息
  addInvoiceInfo: '/doc-exchange/api/payment/addInvoiceInfo', // 保存发票信息
  checkPhone: '/doc-exchange/api/company/checkPhone/v100', // 检查手机
  getDxStatus: '/doc-exchange/api/company/getDxStatus/v100', // 获取首营资料审核状态
  getQRpayPaymentInfo: '/doc-exchange/api/payment/getQRpayPaymentInfo', // 微信扫码支付
  checkRegistPhone: '/doc-exchange/api/manager/checkRegistPhone/v210', // 检查手机号码是否为药师帮会员
  singleRegist: '/doc-exchange/api/company/regist/v210', // 独立注册
  checkCompanyName: '/doc-exchange/api/company/checkCompanyName/v210', // 独立注册-检查企业名称
  confirmInfo: '/doc-exchange/api/company/confirmInfo/v300', // 确认信息
  getYsbContacts: '/doc-exchange/api/company/getYsbContacts/v510', // 获取商务对接人列表
  checkUnifiedNo: '/doc-exchange/api/company/checkUnifiedNo', // 校验统一社会信用代码
  getCurrentYsbContact: '/doc-exchange/api/company/getYsbContactByCompanyId/v518', // 获取当前商务对接人联系方式
  getYsbContactByCompanyAreaCode: '/doc-exchange/api/company/getYsbContactByCompanyAreaCode/v518', // 根据公司地区获取推荐的药师帮商务对接人信息列表
  changeYsbContact: '/doc-exchange/api/company/changeYsbContact/v518', // 修改商务对接人
  getAllStoreTypeList: '/doc-exchange/api/company/getAllStoreType/v518', // 新店入驻流程-获取店铺所有类型
  changeStoreType: '/doc-exchange/api/company/changeStoreType/v521', // 更换店铺类型
  getReasaonForSecondAuditFailed: '/doc-exchange/api/company/getReasonForNotPassingTheSecondAudit/v518', // 新店入驻流程-获取二审不通过原因
  getDistrictById: '/doc-exchange/api/company/getDistributionBusinessAreaByCompanyId/v5240', // 新店入驻流程-通过公司id获取配送商圈列表
  getLetterAndAgreement: '/doc-exchange/api/company/getLetterAndAgreement/v5240', // 新店入驻-获取合作协议和收款委托书
  getAgreementTemplate: '/doc-exchange/api/company/getAgreementTemplateByCompanyId/v518', // 新店入驻流程-获取协议模板
  generateAgreement: '/doc-exchange/api/company/saveOtherInfoBeforeUploadGuaranteeAmtUrl/v518', // 新店入驻-上传信息生成协议和委托书
  uploadGuarantee: '/doc-exchange/api/company/uploadGuaranteeAmtUrl/v518', // 新店入驻-上传保证金
  getGuaranteeAmtInfo: '/doc-exchange/api/company/getGuaranteeAmtInfo/v518', // 新店入驻-获取已上传保证金信息
  getProviderApplyIntro: '/doc-exchange/api/company/getProviderApplyIntro/v518', // 新店入驻-获得上传保证金页面配置文案
  getReasonForGuaranteeFailed: '/doc-exchange/api/company/getReasonForNotPassingTheGuaranteeAmt/v518', // 新店入驻-获取保证金不通过理由
  checkLackOrExpiredDoc: '/doc-exchange/api/company/checkDocLackOrOverOrInReview/v521', // 检查是否有缺少的证件或者过期的证件
  changeToProviderMoveIn: '/doc-exchange/api/company/changeToProviderMoveIn/v521', // 正常使用的用户，自助申请成为药师帮入驻类型
  changeRegType: '/doc-exchange/api/company/changeRegType/v521', // 审核中的药师帮入驻商户，修改注册用户类型
  checkCompanyNameAndCreditCode: '/doc-exchange/api/company/checkCompanyNameAndCreditCode', // 通过企业名和统一信用编码检查是否在黑名单中
};

export const managers = {
  getManagers: '/doc-exchange/api/manager/getManagers/v100', // 管理员信息
  completeManagerInfo: '/doc-exchange/api/company/completeManagerInfo/v100', // 完善管理员信息
  operateManager: '/doc-exchange/api/manager/operateManager/v100', // 操作管理员信息
  getSuperManagerInfo: '/doc-exchange/api/manager/getSuperManagerInfo/v130', // 获取超级管理员信息
  getManagerPermission: '/doc-exchange/api/manager/getManagerPermission/v510', // 获取普通管理员权限
  updatePermission: '/doc-exchange/api/manager/updatePermission/v510', // 设置普通管理员权限
  getDxMenus: '/doc-exchange/api/company/getDxMenus/v510', // 获取菜单权限字典
  getCompanyInfosWhenChangingSuperAdmin: '/doc-exchange/api/company/getCompanyInfosWhenChangingSuperAdmin/v100', // 获取未登录状态下更换超管时的公司信息
  getChangeAdminStatus: '/doc-exchange/api/company/getChangeAdminStatus/v100', // 获取变更超管状态
  getAdminInfosWhenChangingSuperAdmin: '/doc-exchange/api/company/getAdminInfosWhenChangingSuperAdmin/v100', // 获取更换超管时的超管信息（被驳回重新申请时调用）
  createSuperAdmin: '/doc-exchange/api/company/createSuperAdmin/v100', // 申请变更超管账号
};

/*
 *  公共接口 - 上传图片
 * */
export const commons = {
  uploadImage: '/file-service/api/uploadImage/v4010', // 上传图片
  getVerificationCode: '/commons-api/api/security/sendVerificationCode/v4090', // 获取短信验证码，
  getVoiceVeriCode: '/commons-api/api/security/sendVerificationCodeByCall/v4090', // 获取语音验证码
  // 忘记密码时获取验证码(0-短信 1-语音)
  getVerifyCodeWhenForgetPwd: '/doc-exchange/api/auth/checkPhone/v526',
  getPlatformProtocol: '/commons-api/api/getSysConf/v4070', // 获取平台协议
  getPlatformConfig: '/commons-api/api/getSysConfV2', // 获取平台配置
  getAreas: '/commons-api/api/getChildrenAreas/v4070', // 获取地区列表
  checkVerification: '/commons-api/api/security/checkVerificationCode/v4090', // 验证短信验证码
  getYsbUsers: '/doc-exchange/api/company/getYsbUsers/v320', // 获取药店关联药师帮账号
  applyCompany: '/doc-exchange/api/company/applyCompany/v320', // 申请开通首营资料交换平台
  twoMetaCheck: '/commons-api/api/common/checkNameAndId', // 二要素验证
  getQiNiuUploadImgInfo: '/doc-exchange/api/company/getQiNiuUploadImgInfo', // 获取七牛上传图片信息
  ysbUpload2QiNiu: '/doc-exchange/api/company/uploadToQiNiu', // 上传文件到七牛
  getUploadCloudInfo: '/doc-exchange/api/company/getUploadCloudInfo', // 获取上传云必要信息
};

/**
 * 支付、订单
 */
export const order = {
  getPaymentId: '/doc-exchange/api/order/getPaymentId/v100', // 生成支付订单
  webGatewayPay: '/doc-exchange/api/payment/webGatewayPay', // 网关支付
  getCaChargeConfig: '/doc-exchange/api/order/getNewCaChargeConfig/v120', // 获取CA资费配置
};

/*
 *  签章发送
 * */
export const signature = {
  delUnSendCert: '/doc-exchange/api/company/delUnSendCert/v110', // 删除签章记录
  getUnSendCertListByPage: '/doc-exchange/api/company/getUnSendCertListByPage/v130', // 获取待发送签章列表(分页)
  sendAccInfoForEx: '/doc-exchange/api/company/sendAccInfoForEx/v110', // 发送签章
  getExchangeLogFileById: '/doc-exchange/api/company/listExchangeLogFile/v110', // 获取签章列表 待发送文件/已发送文件 列表
};

/*
 * 新建资料
 * */
export const esignadd = {
  addNewCertInfo: '/doc-exchange/api/company/addNewCertInfo/v110', // 新建证件资料
  companyInfoAutoComplete: '/doc-exchange/api/company/companyInfoAutoComplete/v110', // 新建证件资料-搜索企业名称自动补全
  loadCompanyInfoBeforeAddNewCert: '/doc-exchange/api/company/loadCompanyInfoBeforeAddNewCert/v110', // 新建证件资料-加载企业信息
  settleIn: '/doc-exchange/api/company/settleIn/v130', // 邀请入驻
  getSendEmailFee: '/doc-exchange/api/company/getSendEmailFee/v210', // 获取发送邮件费用
  checkDrugQualityAvailable: '/doc-exchange/api/company/canUseDrugQuality/v570', // 获取是否可切换商品资质系统
  getDrugReportList: '/doc-exchange/api/drug/searchDrugReports/v570', // 获取商品资质系统-药检报告列表
  getDrugDocList: '/doc-exchange/api/drug/searchDrugDocs/v570', // 获取商品资质系统-商品首营列表
};

/*
 * 我的品种资质
 * */
export const productDocs = {
  /* 填写商品信息 */
  getDrugInfo: '/doc-exchange/api/drug/getDrugInfo/v200', // 获取商品信息
  searchFactory: '/doc-exchange/api/drug/searchFactory/v200', // 搜索采购平台基准库中的生产厂家
  addDrugInfo: '/doc-exchange/api/drug/addDrugInfoAndDrugDocs/v200', // 新增商品资质信息
  editDrugInfo: '/doc-exchange/api/drug/updateDrugInfoAndDrugDocs/v200', // 更新商品资质信息
  /* 上传文件资质 */
  getDrugDocTypes: '/doc-exchange/api/drug/getDrugDocTypes/v200', // 获取产品资质配置列表
  getExchangeInfoForEdit: '/doc-exchange/api/drug/getExchangeInfoForEdit', // 调整后重新发送 获取要编辑商品信息
  editDrugInfoForExchange: '/doc-exchange/api/drug/updateDrugInfoAndDrugDocsForExchangeLog', // 调整后重新发送 更新商品信息

  // 外部系统调用
  matchDrugInfo: '/doc-exchange/api/drug/matchDrugInfo/v590', // 匹配品种信息
  saveAndAddNewCert: '/doc-exchange/api/company/saveAndAddNewCertInfo/v590', // 保存和新建品种资质发件箱
};

/**
 * websocket
 */
export const socketApi = {
  getNoticeServerIP: '/doc-exchange/api/notice/connect/getNoticeServerIP/v100'
};

/*
 *  忘记密码
 * */
export const forgetPsw = {
  resetPw: '/doc-exchange/api/auth/resetPw/v1030', // 重置密码
};

/**
 * 我的协议
 * */
export const agreement = {
  uploadAgreement: '/doc-exchange/api/company/uploadAgreement/v500', // 上传协议
  getAgreementCompanys: '/doc-exchange/api/company/getAgreementCompanys/v500', // 获取签署企业列表
  searchAgreement: '/doc-exchange/api/company/searchAgreementList/v500', // 获取我的协议
  signAgreement: '/doc-exchange/api/company/signAgreement/v500',
  refuseAgreement: '/doc-exchange/api/company/refuseAgreement/v500', // 拒签协议
  getSendAndSignAgreementFee: '/doc-exchange/api/company/getSendAndSignAgreementFee/v500', // 获取协议发送or签署费用
  sendAgreement: '/doc-exchange/api/company/sendAgreement/v500', // 发送协议
  downloadAgreement: '/doc-exchange/api/company/downloadAgreementZip/v500', // 下载协议
  deleteAgreement: '/doc-exchange/api/company/deleteAgreement/v500', // 删除协议
  withdrawAgreement: '/doc-exchange/api/company/cancelAgreement/v500', // 撤回协议
  recallAgreement: '/doc-exchange/api/company/recallAgreement/v500', // 错签申诉
  searchCanAppealAgreementList: '/doc-exchange/api/company/searchCanAppealAgreementList/v500', // 获取错签申诉列表
  getAgreementLogList: '/doc-exchange/api/company/getAgreementLogList/v500', // 获取协议操作记录
  getMyPayProxyLetters: '/doc-exchange/api/company/getMyPayProxyLetters/v510', // 获取上传收款委托书记录
  getAgreementPagePreviewUrl: '/doc-exchange/api/company/getSealPreviewUrl/v570', // 获取协议指定页码的预览图片url
  hasElectronicFinanceSeal: '/doc-exchange/api/tianwei/hasElectronicFinanceSeal/v100', // 查询企业在天威是否有电子财务章
  exportAgreement: '/doc-exchange/api/company/exportAgreements/v5100', // 导出我的协议
  getAgreementCategories: '/doc-exchange/api/company/getAgreementCategories/v5110', // 获取协议分类
  hasCancelSeal: '/doc-exchange/api/tianwei/hasAnnulmentSeal/v522', // 获取协议分类
  cancelAgreement: '/doc-exchange/api/company/annulmentAgreement/v522', // 发起作废协议
};

/**
 * 通知中心
 * */
export const notification = {
  getNotificationList: '/doc-exchange/api/notification/getNotificationList', // 获取通知列表
  processNotice: '/doc-exchange/api/notification/processNotifications', // 处理通知
};

/**
 * 帮助中心
 * */
export const helpCenter = {
  getHelpDocList: '/doc-exchange/api/help/getHelpDocList', // 获取帮助列表
  getHelpTypeList: '/doc-exchange/api/help/getHelpTypeList', // 获取帮助类型列表
  getHelpDocContent: '/doc-exchange/api/help/getHelpDocContent', // 获取帮助文档内容
};

export default {
  login,
  captcha,
  capitalManage,
  credentials,
  records,
  register,
  managers,
  commons,
  order,
  esignadd,
  socketApi,
  forgetPsw,
  productDocs
};
